import React, { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../../redux/blockchain/blockchainActions";
import { fetchData } from "../../redux/data/dataActions";
import Web3 from "web3";
import { ethers } from "ethers";


import {
  Container,
  InnerContainer,
  LeftContent,
  RightContent,
  CardContainer,
  AvailableContainer,
  MapWrapper,
  CardHeader,
  CardContent,
  CardFooter,
  BlueBottomBar,
  InputWrapper,
  ProgressBarContainer,
  ProgressBarContent,
  ProgressPercent,
  PointWrapper,
  PointContent,
  TooltipWrapper,
  TooltipContent,
  PriceContainer,
  CustomButton
} from './styles'


export const Home = (props) => {

  const theme = useTheme();
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const usdtabi = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"authorizer","type":"address"},{"indexed":true,"internalType":"bytes32","name":"nonce","type":"bytes32"}],"name":"AuthorizationCanceled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"authorizer","type":"address"},{"indexed":true,"internalType":"bytes32","name":"nonce","type":"bytes32"}],"name":"AuthorizationUsed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_account","type":"address"}],"name":"Blacklisted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newBlacklister","type":"address"}],"name":"BlacklisterChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"burner","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newMasterMinter","type":"address"}],"name":"MasterMinterChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"minter","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"minter","type":"address"},{"indexed":false,"internalType":"uint256","name":"minterAllowedAmount","type":"uint256"}],"name":"MinterConfigured","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"oldMinter","type":"address"}],"name":"MinterRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":false,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newAddress","type":"address"}],"name":"PauserChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newRescuer","type":"address"}],"name":"RescuerChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_account","type":"address"}],"name":"UnBlacklisted","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"},{"inputs":[],"name":"CANCEL_AUTHORIZATION_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"RECEIVE_WITH_AUTHORIZATION_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TRANSFER_WITH_AUTHORIZATION_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"authorizer","type":"address"},{"internalType":"bytes32","name":"nonce","type":"bytes32"}],"name":"authorizationState","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_account","type":"address"}],"name":"blacklist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"blacklister","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"authorizer","type":"address"},{"internalType":"bytes32","name":"nonce","type":"bytes32"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"cancelAuthorization","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"minter","type":"address"},{"internalType":"uint256","name":"minterAllowedAmount","type":"uint256"}],"name":"configureMinter","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"currency","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"decrement","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"increment","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"tokenName","type":"string"},{"internalType":"string","name":"tokenSymbol","type":"string"},{"internalType":"string","name":"tokenCurrency","type":"string"},{"internalType":"uint8","name":"tokenDecimals","type":"uint8"},{"internalType":"address","name":"newMasterMinter","type":"address"},{"internalType":"address","name":"newPauser","type":"address"},{"internalType":"address","name":"newBlacklister","type":"address"},{"internalType":"address","name":"newOwner","type":"address"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"newName","type":"string"}],"name":"initializeV2","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"lostAndFound","type":"address"}],"name":"initializeV2_1","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_account","type":"address"}],"name":"isBlacklisted","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isMinter","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"masterMinter","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"minter","type":"address"}],"name":"minterAllowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pauser","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"validAfter","type":"uint256"},{"internalType":"uint256","name":"validBefore","type":"uint256"},{"internalType":"bytes32","name":"nonce","type":"bytes32"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"receiveWithAuthorization","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"minter","type":"address"}],"name":"removeMinter","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IERC20","name":"tokenContract","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"rescueERC20","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"rescuer","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"validAfter","type":"uint256"},{"internalType":"uint256","name":"validBefore","type":"uint256"},{"internalType":"bytes32","name":"nonce","type":"bytes32"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"transferWithAuthorization","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_account","type":"address"}],"name":"unBlacklist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_newBlacklister","type":"address"}],"name":"updateBlacklister","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_newMasterMinter","type":"address"}],"name":"updateMasterMinter","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_newPauser","type":"address"}],"name":"updatePauser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newRescuer","type":"address"}],"name":"updateRescuer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"version","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"}];
  const kyivAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"_burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"_enabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"disable","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"enable","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"},{"internalType":"bool","name":"_flag","type":"bool"}],"name":"setWhitelistMember","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"whitelisted","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"}];
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to get your KYIV token.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [allowance, setAllowance] = useState(0);
  const [usdtAmoumt, setUsdtAmount] = useState(0);
  const [kyivAmount, setKyivAmount] = useState(0);

  const [USDTCONFIG, setUsdtConfig] = useState({
    CONTRACT_ADDRESS: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    }
  });
  const [KYIVConfig, setKyivConfig] = useState({
    CONTRACT_ADDRESS: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    }
  });
  const [presaleAmount, setPresaleAmount] = useState(41200000);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });
  // const { account, activateBrowserWallet, deactivate } = useEthers();
  const claimNFTs = () => {
    setFeedback(`Joining KyivAID DAO...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .purchase(mintAmount * 1000000).send({ from: blockchain.account })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Welcome in KyivAID DAO Community!`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
        addTokenToWallet();
        getKyivAmount();
        getUsdtAmount();
      }).catch(err => {
        console.log(err.message)
        setFeedback("Sorry, Something went wrong!")
        setClaimingNft(false);
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  const getUsdtConfig = async () => {
    const configResponse = await fetch("/config/config_usdt.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    setUsdtConfig(config);
  };

  const getKyivConfig = async () => {
    const configResponse = await fetch("/config/config_kyiv.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    setKyivConfig(config);
  };

  const setAmount = e => {
    const value = e.target.value;
    if (parseFloat(value) >= (20000 - kyivAmount)) {
      setMintAmount(20000 - kyivAmount);
      e.target.value = 20000 - kyivAmount;
    } else if (value <= 0) {
      e.target.value = ''
    } else {
      setMintAmount(value);
    }
  }

  const getAllowance = async () => {
    if (blockchain.account != null) {
      const web3 = new Web3(window.ethereum);
      const UsdtContract = new web3.eth.Contract(usdtabi, USDTCONFIG.CONTRACT_ADDRESS);
      const allowanceAmount = await UsdtContract.methods.allowance(blockchain.account, CONFIG.CONTRACT_ADDRESS).call();
      setAllowance(allowanceAmount);
    }
  }
  const approve = async () => {
    setClaimingNft(true);

    if (blockchain.account != null && allowance <= 0) {
      const web3 = new Web3(window.ethereum);
      const UsdtContract = new web3.eth.Contract(usdtabi, USDTCONFIG.CONTRACT_ADDRESS);
      await UsdtContract.methods.approve(CONFIG.CONTRACT_ADDRESS, 20000000000).send({ from: blockchain.account })
        .then((res) => {
          console.log(res);
          setClaimingNft(false);
          setAllowance(allowance + 20000)
        }).catch(err => {
          // setFeedback("Sorry, Something went wrong!")
          setClaimingNft(false);
        });;
    }
  }
  const getUsdtAmount = async () => {
    if (blockchain.account != null) {
      const web3 = new Web3(window.ethereum);
      const UsdtContract = new web3.eth.Contract(usdtabi, USDTCONFIG.CONTRACT_ADDRESS);
      await UsdtContract.methods.balanceOf(blockchain.account).call()
        .then((res) => {
          setUsdtAmount(Number.parseFloat(res / (10 ** 6)).toFixed(2));
        });
    }
  }
  const getKyivAmount = async () => {
    if (blockchain.account != null) {
      const web3 = new Web3(window.ethereum);
      const KyivContract = new web3.eth.Contract(kyivAbi, KYIVConfig.CONTRACT_ADDRESS);
      await KyivContract.methods.balanceOf(blockchain.account).call().then((res) => {
        setKyivAmount(Number.parseFloat(res / (10 ** 6)).toFixed(2));
      });
    }
  }

  const getKyivPresale = async () => {
    if (blockchain.account != null) {
      const web3 = new Web3(window.ethereum);
      const KyivContract = new web3.eth.Contract(kyivAbi, KYIVConfig.CONTRACT_ADDRESS);
      await KyivContract.methods.balanceOf(CONFIG.CONTRACT_ADDRESS).call().then((res) => {
        setPresaleAmount(Number.parseFloat(res / (10 ** 6)).toFixed(2));
      });
    }
  }

  const addTokenToWallet = async () => {
    try {
      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: KYIVConfig.CONTRACT_ADDRESS,
            symbol: 'KYIV',
            decimals: 6,
            image: 'https://kyivaid.com/images/token.png',
          },
        },
      });

      if (wasAdded) {
        console.log('KYIV Token has been added');
      } else {
        console.log('KYIV Token has not been added');
      }
    } catch (error) {
      console.log(error);
    }
  }
  const disconnect = async () => {
    window.location.reload();
  }

  useEffect(() => {
    getKyivConfig();
    getConfig();
    getUsdtConfig();
  }, []);

  useEffect(() => {
    getData();
    getKyivAmount();
    getUsdtAmount();
    getAllowance();
    getKyivPresale();
  }, [blockchain.account]);


  const percent = Number.parseFloat((41200000 - presaleAmount) * 100 / 41200000).toFixed(2);

  return (
    <Container bgimage={theme.images.bgimage}>
      <InnerContainer>
        <LeftContent>
          <MapWrapper>
            <a href='https://www.kyivaid.com'><img src={theme.images.map} alt='KyivAID.com Home' /></a>
          </MapWrapper>
          <CardContainer>
            <CardHeader>
              <p>DAO <span>$</span>KYIV</p>
              <p>token distribution</p>
              <p>is live!</p>
            </CardHeader>
            <CardContent>
              <p className='content-title'>
                Become active member of revolutionary KyivAID DAO initiative.
              </p>
              <p>
                Every token will give you voting power in our KyivAID Charity DAO.
              </p>
              <p>
                Funds from the sale will be automatically transferred into the charity multisig
              </p>
              <p>treasury : 0x911853E88297fBb605c701f11E35Fef7E84224ad</p>
              <p>Your donations means you are in complete control over how </p>
              <p>we will distribute funds from the treasury.</p>
              <p className='head-line'>We are Web3.0!</p>
              <p className='head-line'>We are DAO!</p>
              <p className='head-line'>We are for Ukraine!</p>
              <p className=''>Every person who will buy over 1000 tokens will receive <span>NFT badge</span> airdropped in <span>Q2</span></p>
              <p className='bold'>+1000x $KYIV - Bronze NFT Supporter Badge</p>
              <p className='bold'>+5000x $KYIV - Silver NFT Supporter Badge</p>
              <p className='bold'>+10000x $KYIV - Gold NFT Supporter Badge</p>
              <p className='bold'>20000x $KYIV - Platinium NFT Supporter Badge</p>
            </CardContent>
            <CardFooter>
              <p>Wallet Cap <span>20,000</span>$KYIV</p>
              <p>Min. Transaction Amount <span>1</span>$KYIV</p>
            </CardFooter>
            <BlueBottomBar />
          </CardContainer>
        </LeftContent>
        <RightContent>
          <AvailableContainer>
            <legend align='center'>Available</legend>
            <p className='distance'>41.2<span>m</span></p>
            <div className='left'>
              <div />
              <span>Left</span>
              <div />
            </div>
            <p className='number'>{data.totalSupply}</p>
            <div className='bottom'>
              <div />

              <span>1 $KIYIV DAO token = 1 USDC</span>
              <div />
            </div>
          </AvailableContainer>

          <ProgressBarContainer>
            <ProgressBarContent>
              <ProgressPercent style={{ width: `${percent}%` }}>
                {(percent !== 0 || percent !== 100) && (
                  <PointWrapper>
                    <PointContent>
                      {blockchain.account ? (
                        <>
                          <TooltipWrapper>
                            <TooltipContent>
                              <span className='bold'>Distributed {percent}%</span>
                              <span>{41200000 - presaleAmount} $KYIV</span>
                            </TooltipContent>
                          </TooltipWrapper>
                        </>
                      ) : ""}
                    </PointContent>
                  </PointWrapper>
                )}
              </ProgressPercent>
            </ProgressBarContent>
          </ProgressBarContainer>


          {blockchain.account === "" || blockchain.smartContract === null ? (
            <>
              <p>Connect to the {CONFIG.NETWORK.NAME} network</p>
              <CustomButton onClick={(e) => {
                e.preventDefault();
                dispatch(connect());
                getData();
              }}>
                <img src={theme.images.attach} alt='' />
                <span>Connect Wallet</span>
              </CustomButton>

              <PriceContainer>
                <p>Your <span>USDC</span> Balance : <span>0</span></p>
                <p>Max <span>$KYIV</span> left to buy: <span>0</span></p>
                <p>Your <span>$KYIV</span> Balance : <span>0</span></p>
              </PriceContainer>
            </>
          )
            : allowance <= 0 ? (
              <>

                <InputWrapper>
                  <input type={'number'}
                    placeholder='Enter amount in USDC' onChange={setAmount}
                  />
                </InputWrapper>
                <p>Please Click Approve to confirm buying KYIV.</p>
                <CustomButton onClick={(e) => {
                  e.preventDefault();
                  approve();
                  getData();
                }}
                  disabled={claimingNft ? "disabled" : ""}>
                  <img src={theme.images.attach} alt='' />
                  <span>{claimingNft ? "Approving..." : "Approve USDC"}</span>
                </CustomButton>

                <PriceContainer>
                  <p>Your <span>USDC</span> Balance : <span>{usdtAmoumt}</span></p>
                  <p>Max <span>$KYIV</span> left to buy: <span>{20000 - kyivAmount}</span></p>
                  <p>Your <span>$KYIV</span> Balance : <span>{kyivAmount}</span></p>
                </PriceContainer>
              </>
            )
              : (
                <>
                  <InputWrapper>
                    <input type={'number'}
                      placeholder='Enter amount in USDC' onChange={setAmount}
                    />
                  </InputWrapper>
                  <p>{feedback}</p>
                  <CustomButton onClick={(e) => {
                    e.preventDefault();
                    claimNFTs();
                    getData();
                  }}
                    disabled={claimingNft ? "disabled" : ""}>
                    <img src={theme.images.attach} alt='' />
                    <span>{claimingNft ? "Buying..." : "BUY"}</span>
                  </CustomButton>

                  <PriceContainer>
                    <p>Your <span>USDC</span> Balance : <span>{usdtAmoumt}</span></p>
                    <p>Max <span>$KYIV</span> left to buy: <span>{20000 - kyivAmount}</span></p>
                    <p>Your <span>$KYIV</span> Balance : <span>{kyivAmount}</span></p>
                  </PriceContainer>
                </>
              )
          }
          <CustomButton isSmall onClick={disconnect}>
            <span>DISCONNECT</span>
          </CustomButton>
        </RightContent>
      </InnerContainer>
    </Container>
  )
}